export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_OFFSET = 0;
export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
export const DEFAULT_PAGINATION = {
  offset: DEFAULT_OFFSET,
  limit: DEFAULT_PAGE_SIZE,
};
